import React from 'react';
import LearnMore from '@/components/learn-more';
import cx from 'classnames';
import styles from './index.scss';
import { LearningInfo } from '@/api/seller/serv/oec_seller_learning_center_api';
import { useModuleContainer } from '@/containers/homepage-v2/carousel-module/module-container/index.ViewHook';

interface ModuleContainerProps {
  configId?: number;
  title?: string;
  jumpLink?: string;
  articleList?: LearningInfo[];
}

export const ModuleContainer: React.FC<ModuleContainerProps> = props => {
  const { title, articleList, configId } = props;

  const {
    imgSrc,
    curHoverArticle,
    validArticleList,
    setCurHoverArticle,
    jumpToModuleLandingPage,
    jumpToCourse,
  } = useModuleContainer(articleList, title);

  return (
    <section className={styles.container}>
      <header className={styles.header}>
        <span className={styles.title}>{title}</span>
        <LearnMore
          classNames="whitespace-nowrap"
          onClickLearnMore={() => jumpToModuleLandingPage(configId)}
        />
      </header>
      <div className={styles.moduleBox}>
        <div
          className={cx(styles.moduleSlideImg)}
          style={{ backgroundImage: `url(${imgSrc})` }}
        />
        <div className={styles.moduleArticleList}>
          {validArticleList?.map((article, index) => {
            return (
              <p
                className={cx(styles.articleTitle, {
                  [styles.active]: curHoverArticle === index,
                })}
                key={index}
                onClick={() => jumpToCourse(article.learning_id, index)}
                onMouseEnter={() => setCurHoverArticle(index)}>
                <span className={styles.titleHeight}>{article.name}</span>
              </p>
            );
          })}
        </div>
      </div>
    </section>
  );
};
